<button
  *scText="buttonText"
  wlCSCapture
  [wlAutomationId]="
    progressiveFormSelectorKey + '-' + stepId + '-' + value + '-button'
  "
  type="submit"
  class="btn w-100"
  [ngClass]="{
    'btn-primary': buttonType === 'button',
    'btn-outline-primary': buttonType === 'button-outline',
  }"
  (click)="submitForm()"
  wlTrackLink
  [trackLinkInfo]="{
    rendering: rendering,
    field: progressiveFormSelectorKey + ' ' + stepId + ' ' + buttonText,
    type: 'button',
    eventType: 'button-click',
  }"
></button>
